import { useRef } from 'react'

import { Box, Section } from '@factorialco/deprecated-design-system'
import { appUrl } from 'config/Vars'
import { action } from 'mobx'

import { observer } from 'mobx-react'

import InlineTooltip from 'modules/core/components/InlineTooltip'
import InputText from 'modules/core/components/Inputs/Text'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'
import { PASSWORD_REGEX } from 'modules/core/store/models/User'

import PasswordForm from 'modules/personal_settings/lib/forms/Password'

const PasswordSettings = () => {
  const { access } = useCurrentSession()

  const passwordForm = useRef(
    new PasswordForm({
      current_password: '',
      password: '',
    })
  ).current

  const onSubmitPassword = async () => {
    const api = ApiClient()
    const { success } = await asyncAction(() =>
      api.post(`/accesses/${access.id}/change_password`, {
        current_password: passwordForm.get('current_password').value,
        password: newPassword.value,
      })
    )

    if (success) {
      action('on-success', () => {
        passwordForm.setValues({
          current_password: '',
          password: '',
        })
        passwordForm.cleanAll()
        window.location.href = appUrl
      })()
    }
  }

  const currentPassword = passwordForm.get('current_password')
  const newPassword = passwordForm.get('password')
  const isValidPassword = PASSWORD_REGEX.test(newPassword.value)
  const isSamePassword = newPassword.value === currentPassword.value

  return (
    <Section.Form
      illustration="thumb"
      title={i18n.t('personal_settings.change_password')}
      description={i18n.t('personal_settings.change_password_subtitle')}
      onSubmit={onSubmitPassword}
      submitLabel={i18n.t('common.submit')}
      isDirty={passwordForm.isDirty}
      disabled={!isValidPassword}
    >
      <InputText
        label={i18n.t('personal_settings.old_password')}
        field={passwordForm.get('current_password')}
        type="password"
      />
      <InputText
        label={i18n.t('personal_settings.new_password')}
        placeholder={i18n.t('personal_settings.password_placeholder')}
        field={newPassword}
        type="password"
      />
      {!isValidPassword && !isSamePassword && newPassword.value.length > 0 && (
        <Box gap="s8">
          <InlineTooltip arrow="top" type="accent">
            {i18n.t('personal_settings.invalid_password')}
          </InlineTooltip>
        </Box>
      )}
      {isSamePassword && newPassword.value.length > 0 && (
        <Box gap="s8">
          <InlineTooltip arrow="top" type="accent">
            {i18n.t('personal_settings.same_password')}
          </InlineTooltip>
        </Box>
      )}
    </Section.Form>
  )
}

export default observer(PasswordSettings)
